import React, { useState, useEffect } from 'react';

const Timer = ({ launchTimestamp }) => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });
    const [isLaunched, setIsLaunched] = useState(Date.now() >= launchTimestamp);

    useEffect(() => {
        if (isLaunched) return;

        const calculateTimeLeft = () => {
            const difference = launchTimestamp - Date.now();

            if (difference > 0) {
                setTimeLeft({
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor(difference / (1000 * 60 * 60) % 24),
                    minutes: Math.floor(difference / 1000 / 60 % 60),
                    seconds: Math.floor(difference / 1000 % 60)
                });
            } else {
                setIsLaunched(true);
            }
        };

        calculateTimeLeft();
        const timer = setInterval(calculateTimeLeft, 1000);
        return () => clearInterval(timer);
    }, [launchTimestamp, isLaunched]);

    if (isLaunched) {
        return (
            <div className="flex items-center justify-center mb-6 sm:mb-8">
                <a
                    href="https://me.zurian.co.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative font-heading uppercase rounded-full font-bold transition-all duration-300 hover:scale-[1.04] text-xs tracking-[0.18em] px-6 py-3 sm:text-sm sm:tracking-[0.22em] sm:px-10 sm:py-3.5 md:text-[0.95rem] md:tracking-[0.25em] md:px-14 md:py-4"
                    style={{
                        background: 'linear-gradient(135deg, rgba(20, 31, 87, 0.9) 0%, rgba(10, 15, 45, 0.95) 100%)',
                        backdropFilter: 'blur(10px)',
                        WebkitBackdropFilter: 'blur(10px)',
                        border: '1.5px solid rgba(248,226,158,0.65)',
                        color: '#F8E29E',
                        boxShadow: '0 0 32px rgba(212,175,55,0.45), 0 4px 24px rgba(0,0,0,0.3)',
                        textShadow: '0 0 20px rgba(212,175,55,0.6)',
                    }}
                    onMouseEnter={e => {
                        e.currentTarget.style.boxShadow = '0 0 55px rgba(212,175,55,0.75), 0 6px 32px rgba(0,0,0,0.35)';
                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(20, 31, 87, 0.98) 0%, rgba(10, 15, 45, 1.0) 100%)';
                    }}
                    onMouseLeave={e => {
                        e.currentTarget.style.boxShadow = '0 0 32px rgba(212,175,55,0.45), 0 4px 24px rgba(0,0,0,0.3)';
                        e.currentTarget.style.background = 'linear-gradient(135deg, rgba(20, 31, 87, 0.9) 0%, rgba(10, 15, 45, 0.95) 100%)';
                    }}
                >
                    EXPLORE COLLECTION
                </a>
            </div>
        );
    }

    const TimeBox = ({ value, label }) => (
        <div className="relative flex flex-col items-center">
            <div className="px-2 py-1.5 sm:px-2.5 sm:py-2 md:px-3 md:py-2.5 rounded-sm flex items-center justify-center w-8 sm:w-11 md:w-12 bg-primary-beige/90 border border-[#D4C4B8]/50">
                <span className="font-body font-bold text-sm sm:text-lg md:text-xl leading-none text-primary-sky-blue">
                    {String(value).padStart(2, '0')}
                </span>
            </div>
            <span className="absolute top-full mt-1.5 sm:mt-2 font-medium text-[8px] sm:text-[10px] uppercase tracking-wider text-primary-beige whitespace-nowrap">
                {label}
            </span>
        </div>
    );

    const Colon = () => (
        <span className="text-xl sm:text-2xl md:text-3xl font-normal text-primary-beige pb-0.5">
            :
        </span>
    );

    return (
        <div className="flex items-center justify-center gap-1.5 sm:gap-2 md:gap-3 mb-6 sm:mb-8">
            <TimeBox value={timeLeft.days} label="Days" />
            <Colon />
            <TimeBox value={timeLeft.hours} label="Hours" />
            <Colon />
            <TimeBox value={timeLeft.minutes} label="Minutes" />
            <Colon />
            <TimeBox value={timeLeft.seconds} label="Seconds" />
        </div>
    );
};

export default Timer;
